"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _stringConsts = require("../constants/stringConsts");
/**
 * 文字列が空の場合全角ハイフンを返す.
 * @param {string} str -文字列
 */
const emptyToHyphen = function (str) {
  if (str) {
    return str;
  }
  return _stringConsts.STRING_CONSTS.HYPHEN_ZENKAKU;
};

/**
 * 引数で受けた文字列を丸括弧で囲ったものを返却する.<br>
 * 対象文字列が空文字、Null、undefinedの場合はそのまま返却.
 *
 * @param {string} target 対象文字列
 */
const encloseCirKakko = target => {
  return target ? _stringConsts.STRING_CONSTS.KAKKO_CIR_START + target + _stringConsts.STRING_CONSTS.KAKKO_CIR_END : target;
};

/**
 * 改行をスペースに置換する.
 *
 * @param {string} target
 */
const replaceLineBreaksToSpace = target => {
  return target ? target.replace(/\r?\n/g, _stringConsts.STRING_CONSTS.HALF_SPACE) : target;
};

/**
 * 正規表現キーワードをエスケープする.
 *
 * @param {string} target
 */
const escapeRegExp = target => {
  let escapedValue = target;
  escapedValue = escapedValue.split('\\');
  escapedValue = escapedValue.join('\\\\');
  _stringConsts.REGEXP_KEYWORDS.forEach(str => {
    escapedValue = escapedValue.split(str);
    escapedValue = escapedValue.join('\\' + str);
  });
  return escapedValue;
};

/**
 * 指定した部門レベルの組織コードに変換したものを返す.
 * @param {string} soshikiCd -組織コード
 * @param {number} bumonLv -部門レベル
 */
const sliceSoshikiCd = function (soshikiCd, bumonLv) {
  const res = String(soshikiCd).split('-', bumonLv).join('-');
  return res ? res : '';
};

/**
 * 引数の文字列内の比較対象に含まれる文字を全て取り出す。
 * @param {string} sample -比較対象
 * @param {string} str 文字列
 * @param {boolean} dedupe 重複を除く場合true
 * @returns {array} 比較対象に含まれる文字の配列。引数が不正な場合、該当する文字がない場合は空の配列。
 */
const getIncludesCharacters = (str, sample, dedupe) => {
  const chars = [];
  if (!str || !sample) {
    return chars;
  }
  const iterator = str[Symbol.iterator]();
  for (const chr of iterator) {
    if (sample.includes(chr)) {
      chars.push(chr);
    }
  }
  return dedupe ? Array.from(new Set(chars)) : chars;
};
var _default = exports.default = {
  emptyToHyphen,
  encloseCirKakko,
  replaceLineBreaksToSpace,
  escapeRegExp,
  sliceSoshikiCd,
  getIncludesCharacters
};